export default class ApiEmail {
    constructor(Restangular, $http, ApiBaseResponseService) {
        let factory = {};

        factory.sendMail = function(data) {
            return Restangular
                .all('emails/send')
                .post(data)
                .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        };

        factory.resendMail = function(taskId) {
          return Restangular
                .one('emails/resend', taskId)
                .post()
                .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        };

        factory.getAttachment = function(id) {
            return Restangular
                .one('emails/attachments', id)
                .get()
                .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        };

        factory.attachment = function(attachment) {
            return Restangular
                .all('emails/attachments')
                .withHttpConfig({
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    }
                })
                .customPOST(attachment, undefined, undefined, { 'Content-Type': undefined })
                .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        };

        return factory;
    }
}

ApiEmail.inject = ['Restangular', '$http', 'ApiBaseResponseService'];



/** WEBPACK FOOTER **
 ** ./src/app/services/apiEmail.js
 **/